var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowUpIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 509",
    fill: "none",
    d: "M0 0h40v12H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 20 20)",
    clipPath: "url(#arrowUpIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 506",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 880",
    d: "M40.012 5.907l-11.77-5.8a1.446 1.446 0 00-.779-.088C27.185.06 27 .169 27 .29v11.6c0 .121.185.23.463.271a1.445 1.445 0 00.778-.087l11.77-5.8c.216-.107.216-.262 0-.368"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 508",
    d: "M.306 3.553h29.03v5.075H.306z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrowUpIcon.195493ab1efa0ab5.svg";
export { ForwardRef as ReactComponent };